/* eslint-disable */
var icon = require('vue-svgicon')
icon.register({
  'draw_group': {
    width: 24,
    height: 24,
    viewBox: '0 0 24 24',
    data: '<defs><clipPath id="svgicon_draw_group_a"><path pid="0" d="M0 0h24v24H0z"/></clipPath></defs><g clip-path="url(#svgicon_draw_group_a)" _fill="#1d1d1d"><path pid="1" d="M6.54 21H3.5a.5.5 0 01-.5-.5v-3.04a.493.493 0 01.15-.36L14.06 6.19l3.75 3.75L6.89 20.85a.47.47 0 01-.35.15zM18.88 8.87l-3.75-3.75 1.83-1.83a1 1 0 011.41 0l2.34 2.34a1 1 0 010 1.409l-1.829 1.83z"/><path pid="2" data-name="Icon" d="M20.603 18.247a.481.481 0 00-.479-.479h-2.4v-2.4a.48.48 0 00-.959 0v2.4h-2.4a.48.48 0 100 .959h2.4v2.4a.48.48 0 10.959 0v-2.4h2.4a.481.481 0 00.479-.48z"/></g>'
  }
})
